<template>
  <div class="card-box">
    <div v-if="title" class="card-title" :class="[iconSrc ? 'icon-prefix' : 'simple-prefix']">
      <div class="icon-prefix-wrap">
        <img :src="iconSrc">
      </div>
      {{ title }}
    </div>
    <slot />
    <div v-if="showGap" class="card-gap"></div>
  </div>
</template>

<script>
export default {
  name: 'CardBox',
  props: {
    title: {
      type: String,
      default: '',
    },
    iconSrc: {
      type: String,
      default: '',
    },
    showGap: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss" scoped>
.card-box {
  background-color: #fffefd;
}
.card-title {
  display: flex;
  align-items: center;
  padding: 20px 30px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  &.simple-prefix::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 22px;
    background: #2e9adb;
    margin-right: 8px;
  }
  .icon-prefix-wrap {
    display: inline-block;
    width: fit-content;
    height: 22px;
    margin-right: 8px;
    img {
      // width: 100%;
      height: 100%;
    }
  }
}
.card-gap {
  height: 16px;
  background-color: #F2F2F2;
}
</style>
